// 택배사 코드별 송장 조회 페이지 URL을 생성한다.
// 코드는 server/src/routes/settings.ts 의 CARRIER_OPTIONS 와 동기화 유지.

const BUILDERS: Record<string, (n: string) => string> = {
  CJGLS: (n) => `https://www.cjlogistics.com/ko/tool/parcel/tracking?gnbInvcNo=${encodeURIComponent(n)}`,
  LOGEN: (n) => `https://www.ilogen.com/web/personal/trace/${encodeURIComponent(n)}`,
  HANJIN: (n) =>
    `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${encodeURIComponent(n)}`,
  LOTTE: (n) => `https://www.lotteglogis.com/home/reservation/tracking/index?InvNo=${encodeURIComponent(n)}`,
  EPOST: (n) => `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${encodeURIComponent(n)}`,
};

const LABELS: Record<string, string> = {
  CJGLS: 'CJ대한통운',
  LOGEN: '로젠택배',
  HANJIN: '한진택배',
  LOTTE: '롯데택배',
  EPOST: '우체국택배',
};

export function carrierTrackingUrl(carrier: string | null | undefined, trackingNumber: string): string | null {
  const code = (carrier ?? '').toUpperCase();
  const build = BUILDERS[code];
  if (!build) return null;
  return build(trackingNumber);
}

export function carrierLabel(carrier: string | null | undefined): string | null {
  const code = (carrier ?? '').toUpperCase();
  return LABELS[code] ?? null;
}
